<template>
  <div>
    <el-button size="mini" icon="el-icon-plus" type="primary" @click="selectMember" round>选择抄送人</el-button>
    <div class="option">
<!--      <el-checkbox label="允许发起人添加抄送人" v-model="config.shouldAdd"></el-checkbox>-->
    </div>
    <member-items v-model="select"/>
    <member-picker multiple ref="memberPicker" :selected="select" @ok="selected"/>
  </div>
</template>

<script>
import MemberPicker from '../../common/MemberPicker'
import MemberItems from '../MemberItems'

export default {
  name: 'CcNodeConfig',
  components: {MemberPicker, MemberItems},
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    select: {
      get () {
        return this.config.assignedUser || []
      },
      set (val) {
        this.config.assignedUser = val
      }
    }
  },
  data () {
    return {}
  },
  methods: {
    selectMember () {
      this.$refs.memberPicker.show()
    },
    selected (select) {
      this.select = Object.assign([], select)
    },
    removeMemberItem (index) {
      this.select.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.option{
  color: #606266;
  margin-top: 20px;
  font-size: small;
}

.desc{
  font-size: small;
  color: #8c8c8c;
}
.member-item{
  margin: 5px;
}
</style>
